export default __webpack_public_path__ + "static/media/login.b8f6824c.png";